// extracted by mini-css-extract-plugin
export default {"metaData":"style_metaData__t7rz6","xenero":"style_xenero__Phm44","fecha":"style_fecha__HLzLO","temporadas":"style_temporadas__HBpuw"};